export const MARAE_BOOKING_ENDPOINTS = {
    marae: `/contact`,
};
